"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.DataStores = void 0;
var _reactGtmModule = _interopRequireDefault(require("react-gtm-module"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var DataStores = /*#__PURE__*/function (DataStores) {
  DataStores["GoogleAnalytics"] = "GoogleAnalytics";
  return DataStores;
}({});
exports.DataStores = DataStores;
var Analytics = /*#__PURE__*/function () {
  function Analytics() {
    _classCallCheck(this, Analytics);
    _defineProperty(this, "GTM", _reactGtmModule.default);
  }
  _createClass(Analytics, [{
    key: "initialize",
    value: function initialize(gtmId) {
      var analyticsOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var tagManagerArgs = _objectSpread({
        gtmId: gtmId
      }, analyticsOptions);
      this.GTM.initialize(tagManagerArgs);
    }
  }, {
    key: "setUserId",
    value: function setUserId(userId) {
      var dataLayerArgs = {
        dataLayer: {
          userId: userId
        },
        dataLayerName: 'dataLayer'
      };
      this.GTM.dataLayer(dataLayerArgs);
    }
  }, {
    key: "setUserProperties",
    value: function setUserProperties(userProperties) {
      var dataLayerArgs = {
        dataLayer: {
          userProperties: userProperties
        },
        dataLayerName: 'dataLayer'
      };
      this.GTM.dataLayer(dataLayerArgs);
    }
  }, {
    key: "setUserProperty",
    value: function setUserProperty(propertyName, propertyValue) {
      this.setUserProperties(_defineProperty({}, propertyName, propertyValue));
    }
  }, {
    key: "triggerAnalyticsEvent",
    value: function triggerAnalyticsEvent(eventName, eventParams) {
      if (this.GTM) {
        var tagManagerArgs = {
          dataLayer: _objectSpread({
            event: eventName
          }, eventParams)
        };
        this.GTM.dataLayer(tagManagerArgs);
      }
    }
  }, {
    key: "dispatchPageView",
    value: function dispatchPageView(pagePath) {
      this.dispatchEvent('page_view', {
        page_path: pagePath
      });
    }
  }, {
    key: "dispatchEvent",
    value: function dispatchEvent(eventName, event) {
      var dataStore = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [DataStores.GoogleAnalytics];
      var platform = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'React';
      if (dataStore.includes(DataStores.GoogleAnalytics)) {
        this.triggerAnalyticsEvent(eventName, event);
      }
    }
  }]);
  return Analytics;
}();
var _default = new Analytics();
exports.default = _default;